
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/press/all-articles",
      function () {
        return require("private-next-pages/[lang]/press/all-articles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/press/all-articles"])
      });
    }
  